'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$1(ps$49) {
  this.a6H = null;
  this.a6H = ps$49;
}
export { $c_Lmealorama_jsonCodecs$package$$anon$1 as $c_Lmealorama_jsonCodecs$package$$anon$1 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$1;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$1() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$1 as $h_Lmealorama_jsonCodecs$package$$anon$1 };
$h_Lmealorama_jsonCodecs$package$$anon$1.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a6H.a.length;
});
$p.g = (function(i) {
  return this.a6H.a[i];
});
var $d_Lmealorama_jsonCodecs$package$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$1, "mealorama.jsonCodecs$package$$anon$1", ({
  I7: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$1 as $d_Lmealorama_jsonCodecs$package$$anon$1 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$1.js.map
